import { render, staticRenderFns } from "./ImageWithHotspots.vue?vue&type=template&id=d22fcbd8&"
import script from "./ImageWithHotspots.vue?vue&type=script&lang=ts&"
export * from "./ImageWithHotspots.vue?vue&type=script&lang=ts&"
import style0 from "./ImageWithHotspots.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports